export const REAL_ESTATE_DEPARTMENTS = [
  { value: 'REAL_ESTATE', viewValue: 'Real Estate' },
  { value: 'LAND_SERVICES', viewValue: 'Land Services' },
];

export const PRJ_EXPENDITURE_TYPES = [
  { value: 'FM', viewValue: 'FM' },
  { value: 'PM', viewValue: 'PM' },
  { value: 'MYRP', viewValue: 'MYRP' },
];

export const FUNDING_TYPES = [
  { value: 'ADVANCE', viewValue: 'Advance' },
  { value: 'ADV_SUPPLEMENTAL', viewValue: 'Advance - Supplemental' },
  { value: 'FULL', viewValue: 'Full' },
  { value: 'FULL_SUPPLEMENTAL', viewValue: 'Full - Supplemental' },
];

export const UPDATE_TYPES_CHECKBOX = [
  { value: 'ESTIMATE', viewValue: 'Estimate' },
  { value: 'DATE', viewValue: 'Date' },
  { value: 'SCOPE', viewValue: 'Change in Scope' },
];

export const UPDATE_REVISION = Array.from({ length: 10 }, (_, i) => {
  const value = (i + 1).toString();
  return { value, viewValue: value };
});

export const STATES = [
  { value: 'CA', viewValue: 'California' },
  { value: 'CO', viewValue: 'Colorado' },
  { value: 'CT', viewValue: 'Connecticut' },
  { value: 'DC', viewValue: 'District of Columbia' },
  { value: 'FL', viewValue: 'Florida' },
  { value: 'IN', viewValue: 'Indiana' },
  { value: 'KS', viewValue: 'Kansas' },
  { value: 'KY', viewValue: 'Kentucky' },
  { value: 'NC', viewValue: 'North Carolina' },
  { value: 'OH', viewValue: 'Ohio' },
  { value: 'SC', viewValue: 'South Carolina' },
  { value: 'TN', viewValue: 'Tennessee' },
  { value: 'TX', viewValue: 'Texas' },
  { value: 'WI', viewValue: 'Wisconsin' },
  { value: 'WY', viewValue: 'Wyoming' },
];

export const DEPARTMENTS = [
  { viewValue: 'RE Fac Asset Mgmt-Carolina East', value: 'CE' },
  { viewValue: 'RE Fac Asset Mgmt-Carolina West', value: 'CW' },
  { viewValue: 'RE Fac Asset Mgmt-Charlotte', value: 'CT' },
  { viewValue: 'RE Fac Asset Mgmt-Florida', value: 'FL' },
  { viewValue: 'RE Fac Asset Mgmt-Midwest', value: 'MW' },
  { viewValue: 'RE Strategy', value: 'ST' },
  { viewValue: 'RE Transactions', value: 'TN' },
];

export const LAND_SERVICES_DEPARTMENTS = [
  { viewValue: 'RE Strategy', value: 'ST' },
  { viewValue: 'RE Transactions', value: 'TN' },
];

export const PROJECT_REASONS = [
  { value: 'END_OF_LIFE_EXISTING', viewValue: 'End of Life of existing asset' },
  { value: 'FAILURE_OF_EXISTING', viewValue: 'Failure of existing asset' },
  { value: 'ADD_NEW_ASSET', viewValue: 'Addition of new asset' },
];

export const PROJECT_CLASS = [
  { value: 'BA-Fossil Steam Plant' },
  { value: 'BB-Nuclear Steam Plant' },
  { value: 'BC-Hydro Plants' },
  { value: 'DP - Distribution Plant (N/C)' },
  { value: 'DT - Substations Dist/Tran MW only' },
  { value: 'FF - Transmission Stations' },
  { value: 'GG - Transmission Lines' },
  { value: 'HB - Distributions Substation' },
  { value: 'HC  - Customer Substations' },
  { value: 'RR - Communication' },
  { value: 'SA - Gen. Bldg. & Oper. Centers' },
  { value: 'TA - Gen Bldg/Land/Furniture' },
  { value: 'TB - Equipment & Tools' },
  { value: 'TC - Automotive Equipment' },
  { value: 'TD - Office Equipment' },
  { value: 'TE - Mobile Construction Equipment' },
  { value: 'TP - Transmission Plant' },
  { value: 'VS - Intangible Plant - Software' },
  { value: 'VT - Software Five Year' },
  { value: 'ZB - Midwest Gas Delivery' },
  { value: 'ZD - Gas Delivery' },
  { value: 'ZH - Gas Distribution' },
  { value: 'ZI - Gas Building & Grounds' },
  { value: 'ZJ - Gas General' },
  { value: 'ZK - Shared Services O&M' },
  { value: 'ZL - RBU O&M' },
  { value: 'ZS - LNGPL LNG' },
  { value: 'ZV- Gas Services' },
  { value: 'ZW - O&M Projects' },
];

export const EST_WORK_TASKS = [
  { value: 'Audio/Visual', viewValue: 'Duke Labor and/or Contractor Labor' },
  {
    value: 'Construction',
    viewValue: 'Roofing, Paving, Fire Protection, Equip, MEP, Elevators, Artwork, etc.',
  },
  { value: 'Contingency', viewValue: 'Contingency' },
  {
    value: 'Design Services',
    viewValue: 'Architect, MEP Engineer, Consultant',
  },
  {
    value: 'Duke Midwest Facility Management',
    viewValue: 'Facilities Maintenance Staff (Midwest)',
  },
  {
    value: 'Duke Project Management',
    viewValue: 'Special projects that require Duke direct Project Management labor',
  },
  {
    value: 'EHS - Hazemat/Asbestos/Abatement',
    viewValue: 'Work for Hazmat/Asbestos Abatement/Lead Abatement',
  },
  {
    value: 'Furniture and/or AV Equipment',
    viewValue: 'Moving, FF&E, Furniture and AV Equipment',
  },
  {
    value: 'Internal Service Provider',
    viewValue: 'Other Internal Service Provider Duke Labor and/or Contractor Labor',
  },
  {
    value: 'JLL Facility Management',
    viewValue: 'JLL Facilities Team Support',
  },
  { value: 'JLL Project Management', viewValue: 'Project Manager, MAC, OP' },
  {
    value: 'JLL Project Management & Principal Fee',
    viewValue: 'JLL Project Management & Principal Fee',
  },
  { value: 'Materials', viewValue: 'Materials for the project' },
  { value: 'Removal', viewValue: 'Demolition/Retirement' },
  {
    value: 'Safety - EHS Support',
    viewValue: 'EHS Support - Duke Employee Labor/Contractor Labor',
  },
  {
    value: 'Sustainability',
    viewValue:
      'Duke Labor and/ or JLL Sustainability contractor labor for review of drawings and recommendations',
  },
  { value: 'Telecom and IT', viewValue: 'Duke Labor and/or Contractor Labor' },
];

export const EST_EXPENDITURE_TYPES = [{ value: 'Capital Exp' }, { value: 'Operating Exp' }];

export const EST_ACTIVITY_IDS = [
  {
    valueId: 'I-Install',
    expendType: 'Capital Exp',
    chargeIndicator: 'CWIP - Additions',
  },
  {
    valueId: 'REI-Install-Customer',
    expendType: 'Capital Exp',
    chargeIndicator: 'CWIP - Additions',
  },
  { valueId: 'OM-O&M', expendType: 'Operating Exp', chargeIndicator: 'O&M' },
  {
    valueId: 'REOM-O&M-Customer',
    expendType: 'Operating Exp',
    chargeIndicator: 'O&M',
  },
  {
    valueId: 'R-Removal',
    expendType: 'Capital Exp',
    chargeIndicator: 'RWIP - Removal',
  },
  {
    valueId: 'RER-Removal-Customer',
    expendType: 'Capital Exp',
    chargeIndicator: 'RWIP - Removal',
  },
];

export const EST_PRJ_CHARGE_INDICATORS = [
  { valueType: 'CWIP - Additions' },
  { valueType: 'O&M' },
  { valueType: 'RWIP - Removal' },
];

export const EST_CHARGE_TYPES = [
  { value: 'Contractor' },
  { value: 'Labor' },
  { value: 'Material' },
  { value: 'Other' },
];

export const RESPONSIBILITY_CODES = [
  { value: '4016', description: '4016- Project Development Staff (RE)' },
  { value: '4019', description: '4019 - Car West Regional Fac - JLL PM (RE)' },
  { value: '8925', description: '8925 - Charlotte Regional Fac - JLL PM (RE)' },
  { value: '9348', description: '9348 - Event Technical Services (SS)' },
  { value: 'J944', description: 'J944 - Car East Regional Fac - JLL PM RE' },
  { value: 'S414', description: 'S414 - Utility (AU)' },
  { value: 'S735', description: 'S735 - Midwest Regional Fac - FM Tech ' },
  {
    value: 'S737',
    description: 'S737 - Midwest Regional Fac - JLL OH FM (RE)',
  },
  { value: 'S740', description: 'S740 - Midwest Regional FAC - Staff' },
  { value: 'S742', description: 'S742 - Midwest Regional Fac - JLL PM (RE)' },
  { value: 'W320', description: 'W320 - Florida Regional FAC - JLL PM (RE)' },
];

export const REGIONS = [
  { value: 'DE Carolina West', viewValue: 'DE Carolina West' },
  { value: 'DE Florida', viewValue: 'DE Florida' },
  { value: 'DE Indiana', viewValue: 'DE Indiana' },
  { value: 'DE Kentucky', viewValue: 'DE Kentucky' },
  { value: 'DE Ohio', viewValue: 'DE Ohio' },
  { value: 'DE Progress Carolina', viewValue: 'DE Progress Carolina' },
  { value: 'DEBS', viewValue: 'DEBS' },
  { value: 'PNG', viewValue: 'PNG' },
];

export const BUSINESS_UNITS = [
  {
    value: '20003 - DE Carolinas Fossil Steam Prod',
    viewValue: '20003 - DE Carolinas Fossil Steam Prod',
    fundingProject: 'RES20003',
  },
  {
    value: '20005 - DE Carolinas Hydro Prod',
    viewValue: '20005 - DE Carolinas Hydro Prod',
    fundingProject: 'RES20005',
  },
  {
    value: '20013 - Service Company',
    viewValue: '20013 - Service Company',
    fundingProject: 'RESBLDCA',
  },
  {
    value: '20017 - Power Delivery (DE Carolinas West)',
    viewValue: '20017 - Power Delivery (DE Carolinas West)',
    fundingProject: 'RESBCAET',
  },
  {
    value: '20018 - DE Carolinas Other',
    viewValue: '20018 - DE Carolinas Other',
    fundingProject: 'RESBLDCW',
  },
  {
    value: '20048 - DE Carolinas Nuclear - Catawba Common',
    viewValue: '20048 - DE Carolinas Nuclear - Catawba Common',
    fundingProject: 'RESBLDCW',
  },
  {
    value: '20048 - DE Carolinas Nuclear - Lee Common',
    viewValue: '20048 - DE Carolinas Nuclear - Lee Common',
    fundingProject: 'RESBLDCW',
  },
  {
    value: '20048 - DE Carolinas Nuclear - McGuire Common',
    viewValue: '20048 - DE Carolinas Nuclear - McGuire Common',
    fundingProject: 'RESBLDCW',
  },
  {
    value: '20048 - DE Carolinas Nuclear - Oconee Common',
    viewValue: '20048 - DE Carolinas Nuclear - Oconee Common',
    fundingProject: 'RESBLDCW',
  },
  {
    value: '20049 - DE Carolinas Customer Service',
    viewValue: '20049 - DE Carolinas Customer Service',
    fundingProject: 'RESBLDCA',
  },
  { value: '20090 - NP&L Support', viewValue: '20090 - NP&L Support', fundingProject: 'RESBLDCA' },
  { value: '20091 - NP&L Hydro', viewValue: '20091 - NP&L Hydro', fundingProject: 'RESBLDCA' },
  {
    value: '20093 - DE NP&L Power Delivery',
    viewValue: '20093 - DE NP&L Power Delivery',
    fundingProject: 'RESBLDCA',
  },
  {
    value: '20094 - Customer Services - NP&L',
    viewValue: '20094 - Customer Services - NP&L',
    fundingProject: 'RESBLDCA',
  },
  {
    value: '47106 - PNG Delivery - NC',
    viewValue: '47106 - PNG Delivery - NC',
    fundingProject: 'RESPIEDMT',
  },
  {
    value: '47126 - PNG Delivery -SC',
    viewValue: '47126 - PNG Delivery -SC',
    fundingProject: 'RESPIEDMT',
  },
  {
    value: '47136 - PNG Delivery - TN',
    viewValue: '47136 - PNG Delivery - TN',
    fundingProject: 'RESPIEDMT',
  },
  {
    value: '47146 - PNG Delivery - 2 State',
    viewValue: '47146 - PNG Delivery - 2 State',
    fundingProject: 'RESPIEDMT',
  },
  {
    value: '47156 - PNG Delivery - 3 State',
    viewValue: '47156 - PNG Delivery - 3 State',
    fundingProject: 'RESPIEDMT',
  },
  {
    value: '50120 - PE Carolinas Other',
    viewValue: '50120 - PE Carolinas Other',
    fundingProject: 'RESBLDCE',
  },
  {
    value: '50121 - PE Carolinas Fossil',
    viewValue: '50121 - PE Carolinas Fossil',
    fundingProject: 'RESBLDCEF',
  },
  {
    value: '50122 - Sutton 2x1 Combined Cycle',
    viewValue: '50122 - Sutton 2x1 Combined Cycle',
    fundingProject: '50122',
  },
  {
    value: '50123 - PE Carolinas Hydro',
    viewValue: '50123 - PE Carolinas Hydro',
    fundingProject: 'REPEHYDRO',
  },
  {
    value: '50125 - PE Carolinas Nuclear - Brunswick Common',
    viewValue: '50125 - PE Carolinas Nuclear - Brunswick Common',
    fundingProject: 'RESBLDCE',
  },
  {
    value: '50125 - PE Carolinas Nuclear - Harris Common',
    viewValue: '50125 - PE Carolinas Nuclear - Harris Common',
    fundingProject: 'RESBLDNUC',
  },
  {
    value: '50125 - PE Carolinas Nuclear - Robinson Common',
    viewValue: '50125 - PE Carolinas Nuclear - Robinson Common',
    fundingProject: 'RESBLDCE',
  },
  {
    value: '50126 - PE Carolinas Power Delivery',
    viewValue: '50126 - PE Carolinas Power Delivery',
    fundingProject: 'RESBLCETD',
  },
  {
    value: '50127 - PE Carolinas Customer Services',
    viewValue: '50127 - PE Carolinas Customer Services',
    fundingProject: 'RESBLDCE',
  },
  {
    value: '50220 - PE Florida Other',
    viewValue: '50220 - PE Florida Other',
    fundingProject: 'RESBLDFL',
  },
  {
    value: '50221 - PE Florida Fossil Anclote',
    viewValue: '50221 - PE Florida Fossil Anclote',
    fundingProject: 'RESFLFOS',
  },
  {
    value: '50225 - PE Florida Nuclear - Crystal River',
    viewValue: '50225 - PE Florida Nuclear - Crystal River',
    fundingProject: 'RESBLDFL',
  },
  {
    value: '50226 - PE Florida Power Delivery',
    viewValue: '50226 - PE Florida Power Delivery',
    fundingProject: 'RESBLFLTD',
  },
  {
    value: '50227 - PE Florida Customer Services',
    viewValue: '50227 - PE Florida Customer Services',
    fundingProject: 'RESBLDFL',
  },
  {
    value: '75023 - DE Ohio Power Deliv - Elec',
    viewValue: '75023 - DE Ohio Power Deliv - Elec',
    fundingProject: 'RESBLDOH',
  },
  {
    value: '75024 - DE Ohio Cus Services - Elec',
    viewValue: '75024 - DE Ohio Cus Services - Elec',
    fundingProject: 'RESBLDOH',
  },
  {
    value: '75025 - DE Ohio Other - Elec',
    viewValue: '75025 - DE Ohio Other - Elec',
    fundingProject: 'RESBLDOH',
  },
  {
    value: '75026 - DE Ohio Gas Delivery',
    viewValue: '75026 - DE Ohio Gas Delivery',
    fundingProject: 'RESBLDOH',
  },
  {
    value: '75027 - DE Ohio Gas Customer',
    viewValue: '75027 - DE Ohio Gas Customer',
    fundingProject: 'RESBLDOH',
  },
  {
    value: '75028 - DE Ohio Other - Gas',
    viewValue: '75028 - DE Ohio Other - Gas',
    fundingProject: 'RESBLDOH',
  },
  {
    value: '75080 - DE Kentucky Other - Elec',
    viewValue: '75080 - DE Kentucky Other - Elec',
    fundingProject: 'RESBLKY',
  },
  {
    value: '75084 - DE Kentucky Power Deliv - Ele',
    viewValue: '75084 - DE Kentucky Power Deliv - Ele',
    fundingProject: 'RESBLKY',
  },
  {
    value: '75085 - DE Kentucky Cus Service - Ele',
    viewValue: '75085 - DE Kentucky Cus Service - Ele',
    fundingProject: 'RESBLKY',
  },
  {
    value: '75086 - DE Kentucky Gas Delivery',
    viewValue: '75086 - DE Kentucky Gas Delivery',
    fundingProject: 'RESBLKY',
  },
  {
    value: '75087 - DE Kentucky Gas Customer',
    viewValue: '75087 - DE Kentucky Gas Customer',
    fundingProject: 'RESBLKY',
  },
  {
    value: '75088 - DE Kentucky Gas Other',
    viewValue: '75088 - DE Kentucky Gas Other',
    fundingProject: 'RESBLKY',
  },
  {
    value: '75110 - DE Indiana Other',
    viewValue: '75110 - DE Indiana Other',
    fundingProject: 'INNONUTIL',
  },
  {
    value: '75111 - DE Indiana Fossil',
    viewValue: '75111 - DE Indiana Fossil',
    fundingProject: 'RES75111',
  },
  {
    value: '75115 - DE Indiana Power Delivery',
    viewValue: '75115 - DE Indiana Power Delivery',
    fundingProject: 'RESBLDINO',
  },
  {
    value: '75116 - DE Indiana Customer Services',
    viewValue: '75116 - DE Indiana Customer Services',
    fundingProject: 'RESBLDIN',
  },
];

export const PROJECT_TYPES = [
  {
    value: 'SA - Gen. Bldg. & Oper. Centers',
    viewValue: 'SA - Gen. Bldg. & Oper. Centers',
    utilityAccount: 'x9000 Structures and Improvements',
  },
  {
    value: 'SB - General Land',
    viewValue: 'SB - General Land',
    utilityAccount: 'xxxxx Non-depr Land & Land Rights',
  },
  {
    value: 'YA - Non-Utility',
    viewValue: 'YA - Non-Utility',
    utilityAccount: '78900 Non-depr Land & Land Rights',
  },
  {
    value: 'YB - Non-Utility 5 year property',
    viewValue: 'YB - Non-Utility 5 year property',
    utilityAccount: '78900 Non-depr Land & Land Rights',
  },
  {
    value: 'YC - Non-Utility 10 year property',
    viewValue: 'YC - Non-Utility 10 year property',
    utilityAccount: '78900 Non-depr Land & Land Rights',
  },
  {
    value: 'YD - Non-Utility 15 year property',
    viewValue: 'YD - Non-Utility 15 year property',
    utilityAccount: '78900 Non-depr Land & Land Rights',
  },
  {
    value: 'YE - Non-Utility 20 year property',
    viewValue: 'YE - Non-Utility 20 year property',
    utilityAccount: '78900 Non-depr Land & Land Rights',
  },
  {
    value: 'YF - Non-Utility 25 year property',
    viewValue: 'YF - Non-Utility 25 year property',
    utilityAccount: '78900 Non-depr Land & Land Rights',
  },
  {
    value: 'YG - Non-Utility 30 year property',
    viewValue: 'YG - Non-Utility 30 year property',
    utilityAccount: '78900 Non-depr Land & Land Rights',
  },
];

export const LOCATION_TYPES = [
  { value: 'Land', viewValue: 'Land' },
  { value: 'Building and Grounds', viewValue: 'Building and Grounds' },
];

export const BUSINESS_UNIT_DETAILS = [
  {
    businessUnit: '20003 - DE Carolinas Fossil Steam Prod',
    respCenter: '0193 - DE Carolina West Accounting Other',
    capitalOperUnit: 'AS00',
    omOperUnit: 'AS00',
    fundingProject: 'RES20003',
    businessUnitNumber: '20003',
    capitalAccount: '0108600',
    omAccount: '0935100',
    processCode: '',
  },
  {
    businessUnit: '20003 - DE Carolinas Fossil Steam Prod',
    respCenter: '0193 - DE Carolina West Accounting Other',
    capitalOperUnit: 'AS00',
    omOperUnit: 'AS00',
    fundingProject: 'RES20003',
    businessUnitNumber: '20003',
    capitalAccount: '0108600',
    omAccount: '0935100',
    processCode: '',
  },
  {
    businessUnit: '20005 - DE Carolinas Hydro Prod',
    respCenter: '0193 - DE Carolina West Accounting Other',
    capitalOperUnit: 'WY00',
    omOperUnit: 'WY00',
    fundingProject: 'RES20005',
    businessUnitNumber: '20005',
    capitalAccount: '0108600',
    omAccount: '0935100',
    processCode: '',
  },
  {
    businessUnit: '20013 - Service Company',
    respCenter: '9659 - Shared SVCS Corp Accounts',
    capitalOperUnit: 'ICOU',
    omOperUnit: 'DERE',
    fundingProject: 'RESBLDCA',
    businessUnitNumber: '20013',
    capitalAccount: '0108600',
    omAccount: '0935100',
    processCode: '',
  },
  {
    businessUnit: '20017 - Power Delivery (DE Carolinas West)',
    respCenter: '0193 - DE Carolina West Accounting Other',
    capitalOperUnit: 'BLDC',
    omOperUnit: 'BLDC',
    fundingProject: 'RESBCAET',
    businessUnitNumber: '20017',
    capitalAccount: '0108600',
    omAccount: '0935100',
    processCode: 'SACONST',
  },
  {
    businessUnit: '20018 - DE Carolinas Other',
    respCenter: '0193 - DE Carolina West Accounting Other',
    capitalOperUnit: '0830',
    omOperUnit: '0830',
    fundingProject: 'RESBLDCW',
    businessUnitNumber: '20018',
    capitalAccount: '0108600',
    omAccount: '0935100',
    processCode: '',
  },
  {
    businessUnit: '20048 - DE Carolinas Nuclear - Catawba Common',
    respCenter: '0193 - DE Carolina West Accounting Other',
    capitalOperUnit: 'CN00',
    omOperUnit: 'CN00',
    fundingProject: 'RESBLDCW',
    businessUnitNumber: '20048',
    capitalAccount: '0108600',
    omAccount: '0935100',
    processCode: '',
  },
  {
    businessUnit: '20048 - DE Carolinas Nuclear - Lee Common',
    respCenter: '0193 - DE Carolina West Accounting Other',
    capitalOperUnit: 'LN00',
    omOperUnit: 'LN00',
    fundingProject: 'RESBLDCW',
    businessUnitNumber: '20048',
    capitalAccount: '0108600',
    omAccount: '0935100',
    processCode: '',
  },
  {
    businessUnit: '20048 - DE Carolinas Nuclear - McGuire Common',
    respCenter: '0193 - DE Carolina West Accounting Other',
    capitalOperUnit: 'MC00',
    omOperUnit: 'MC00',
    fundingProject: 'RESBLDCW',
    businessUnitNumber: '20048',
    capitalAccount: '0108600',
    omAccount: '0935100',
    processCode: '',
  },
  {
    businessUnit: '20048 - DE Carolinas Nuclear - Oconee Common',
    respCenter: '0193 - DE Carolina West Accounting Other',
    capitalOperUnit: 'ON00',
    omOperUnit: 'ON00',
    fundingProject: 'RESBLDCW',
    businessUnitNumber: '20048',
    capitalAccount: '0108600',
    omAccount: '0935100',
    processCode: '',
  },
  {
    businessUnit: '20049 - DE Carolinas Customer Service',
    respCenter: '0193 - DE Carolina West Accounting Other',
    capitalOperUnit: 'CUS',
    omOperUnit: 'CUS',
    fundingProject: 'RESBLDCA',
    businessUnitNumber: '20049',
    capitalAccount: '0108600',
    omAccount: '0935100',
    processCode: '',
  },
  {
    businessUnit: '20090 - NP&L Support',
    respCenter: '0193 - DE Carolina West Accounting Other',
    capitalOperUnit: '8404',
    omOperUnit: '8404',
    fundingProject: 'RESBLDCA',
    businessUnitNumber: '20090',
    capitalAccount: '0108600',
    omAccount: '0935100',
    processCode: 'SACONST',
  },
  {
    businessUnit: '20091 - NP&L Hydro',
    respCenter: '0193 - DE Carolina West Accounting Other',
    capitalOperUnit: 'NA00',
    omOperUnit: 'NA00',
    fundingProject: 'RESBLDCA',
    businessUnitNumber: '20091',
    capitalAccount: '0108600',
    omAccount: '0935100',
    processCode: 'SACONST',
  },
  {
    businessUnit: '20093 - DE NP&L Power Delivery',
    respCenter: '0193 - DE Carolina West Accounting Other',
    capitalOperUnit: 'BLDN',
    omOperUnit: 'BLDN',
    fundingProject: 'RESBLDCA',
    businessUnitNumber: '20093',
    capitalAccount: '0108600',
    omAccount: '0935100',
    processCode: 'SACONST',
  },
  {
    businessUnit: '20094 - Customer Services - NP&L',
    respCenter: '0193 - DE Carolina West Accounting Other',
    capitalOperUnit: 'NPLR',
    omOperUnit: 'NPLR',
    fundingProject: 'RESBLDCA',
    businessUnitNumber: '20094',
    capitalAccount: '0108600',
    omAccount: '0935100',
    processCode: '',
  },
  {
    businessUnit: '47106 - PNG Delivery - NC',
    respCenter: '0113 - PNG Piedmont Natural Gas Other',
    capitalOperUnit: 'PGDO',
    omOperUnit: 'PGDO',
    fundingProject: 'RESPIEDMT',
    businessUnitNumber: '47106',
    capitalAccount: '0108600',
    omAccount: '0935100',
    processCode: '',
  },
  {
    businessUnit: '47126 - PNG Delivery -SC',
    respCenter: '0113 - PNG Piedmont Natural Gas Other',
    capitalOperUnit: 'PAOC',
    omOperUnit: 'PAOC',
    fundingProject: 'RESPIEDMT',
    businessUnitNumber: '47126',
    capitalAccount: '0108600',
    omAccount: '0935100',
    processCode: '',
  },
  {
    businessUnit: '47136 - PNG Delivery - TN',
    respCenter: '0113 - PNG Piedmont Natural Gas Other',
    capitalOperUnit: 'PNLN',
    omOperUnit: 'PNLN',
    fundingProject: 'RESPIEDMT',
    businessUnitNumber: '47136',
    capitalAccount: '0108600',
    omAccount: '0935100',
    processCode: '',
  },
  {
    businessUnit: '47146 - PNG Delivery - 2 State',
    respCenter: '0113 - PNG Piedmont Natural Gas Other',
    capitalOperUnit: 'PGOZ',
    omOperUnit: 'PGOZ',
    fundingProject: 'RESPIEDMT',
    businessUnitNumber: '47146',
    capitalAccount: '0108600',
    omAccount: '0935100',
    processCode: '',
  },
  {
    businessUnit: '47156 - PNG Delivery - 3 State',
    respCenter: '0113 - PNG Piedmont Natural Gas Other',
    capitalOperUnit: 'PGOP',
    omOperUnit: 'PGOP',
    fundingProject: 'RESPIEDMT',
    businessUnitNumber: '47156',
    capitalAccount: '0108600',
    omAccount: '0935100',
    processCode: '',
  },
  {
    businessUnit: '50120 - PE Carolinas Other',
    respCenter: 'U258 - DE Progress Carolina East Accounting Other',
    capitalOperUnit: 'PECO',
    omOperUnit: 'PECO',
    fundingProject: 'RESBLDCE',
    businessUnitNumber: '50120',
    capitalAccount: '0108600',
    omAccount: '0935100',
    processCode: '',
  },
  {
    businessUnit: '50121 - PE Carolinas Fossil',
    respCenter: 'U258 - DE Progress Carolina East Accounting Other',
    capitalOperUnit: 'AE00',
    omOperUnit: 'AE00',
    fundingProject: 'RESBLDCEF',
    businessUnitNumber: '50121',
    capitalAccount: '0108600',
    omAccount: '0935100',
    processCode: '',
  },
  {
    businessUnit: '50122 - Sutton 2x1 Combined Cycle',
    respCenter: 'U258 - DE Progress Carolina East Accounting Other',
    capitalOperUnit: 'DLC0',
    omOperUnit: 'DLC0',
    fundingProject: '50122',
    businessUnitNumber: '50122',
    capitalAccount: '0108600',
    omAccount: '0935100',
    processCode: '',
  },
  {
    businessUnit: '50123 - PE Carolinas Hydro',
    respCenter: 'U258 - DE Progress Carolina East Accounting Other',
    capitalOperUnit: 'DCHY',
    omOperUnit: 'DCHY',
    fundingProject: 'REPEHYDRO',
    businessUnitNumber: '50123',
    capitalAccount: '0108600',
    omAccount: '0935100',
    processCode: '',
  },
  {
    businessUnit: '50125 - PE Carolinas Nuclear - Brunswick Common',
    respCenter: 'U258 - DE Progress Carolina East Accounting Other',
    capitalOperUnit: 'BN00',
    omOperUnit: 'BN00',
    fundingProject: 'RESBLDCE',
    businessUnitNumber: '50125',
    capitalAccount: '0108600',
    omAccount: '0935100',
    processCode: '',
  },
  {
    businessUnit: '50125 - PE Carolinas Nuclear - Harris Common',
    respCenter: 'U258 - DE Progress Carolina East Accounting Other',
    capitalOperUnit: 'HRN1',
    omOperUnit: 'HRN1',
    fundingProject: 'RESBLDNUC',
    businessUnitNumber: '50125',
    capitalAccount: '0108600',
    omAccount: '0935100',
    processCode: '',
  },
  {
    businessUnit: '50125 - PE Carolinas Nuclear - Robinson Common',
    respCenter: 'U258 - DE Progress Carolina East Accounting Other',
    capitalOperUnit: 'RN02',
    omOperUnit: 'RN02',
    fundingProject: 'RESBLDCE',
    businessUnitNumber: '50125',
    capitalAccount: '0108600',
    omAccount: '0935100',
    processCode: '',
  },
  {
    businessUnit: '50126 - PE Carolinas Power Delivery',
    respCenter: 'U258 - DE Progress Carolina East Accounting Other',
    capitalOperUnit: 'BLDP',
    omOperUnit: 'BLDP',
    fundingProject: 'RESBLCETD',
    businessUnitNumber: '50126',
    capitalAccount: '0108600',
    omAccount: '0935100',
    processCode: 'SACONST',
  },
  {
    businessUnit: '50127 - PE Carolinas Customer Services',
    respCenter: 'U258 - DE Progress Carolina East Accounting Other',
    capitalOperUnit: 'PCNA',
    omOperUnit: 'PCNA',
    fundingProject: 'RESBLDCE',
    businessUnitNumber: '50127',
    capitalAccount: '0108600',
    omAccount: '0935100',
    processCode: '',
  },
  {
    businessUnit: '50220 - PE Florida Other',
    respCenter: 'W220 - DE Florida Accounting Other',
    capitalOperUnit: 'PEFO',
    omOperUnit: 'PEFO',
    fundingProject: 'RESBLDFL',
    businessUnitNumber: '50220',
    capitalAccount: '0108600',
    omAccount: '0935100',
    processCode: '',
  },
  {
    businessUnit: '50221 - PE Florida Fossil Anclote',
    respCenter: 'W220 - DE Florida Accounting Other',
    capitalOperUnit: 'AN00',
    omOperUnit: 'AN00',
    fundingProject: 'RESFLFOS',
    businessUnitNumber: '50221',
    capitalAccount: '0108600',
    omAccount: '0935100',
    processCode: '',
  },
  {
    businessUnit: '50225 - PE Florida Nuclear - Crystal River',
    respCenter: 'W220 - DE Florida Accounting Other',
    capitalOperUnit: 'CRN3',
    omOperUnit: 'CRN3',
    fundingProject: 'RESBLDFL',
    businessUnitNumber: '50225',
    capitalAccount: '0108600',
    omAccount: '0935100',
    processCode: '',
  },
  {
    businessUnit: '50226 - PE Florida Power Delivery',
    respCenter: 'W220 - DE Florida Accounting Other',
    capitalOperUnit: 'BLDF',
    omOperUnit: 'BLDF',
    fundingProject: 'RESBLFLTD',
    businessUnitNumber: '50226',
    capitalAccount: '0108600',
    omAccount: '0935100',
    processCode: 'SACONST',
  },
  {
    businessUnit: '50227 - PE Florida Customer Services',
    respCenter: 'W220 - DE Florida Accounting Other',
    capitalOperUnit: 'PFNA',
    omOperUnit: 'PFNA',
    fundingProject: 'RESBLDFL',
    businessUnitNumber: '50227',
    capitalAccount: '0108600',
    omAccount: '0935100',
    processCode: '',
  },
  {
    businessUnit: '75023 - DE Ohio Power Deliv - Elec',
    respCenter: '9929 - DE Ohio Accounting Other',
    capitalOperUnit: 'BLDO',
    omOperUnit: 'BLDO',
    fundingProject: 'RESBLDOH',
    businessUnitNumber: '75023',
    capitalAccount: '0108620',
    omAccount: '0935100',
    processCode: 'SACONST',
  },
  {
    businessUnit: '75024 - DE Ohio Cus Services - Elec',
    respCenter: '9929 - DE Ohio Accounting Other',
    capitalOperUnit: 'AC01',
    omOperUnit: 'AC01',
    fundingProject: 'RESBLDOH',
    businessUnitNumber: '75024',
    capitalAccount: '0108620',
    omAccount: '0935100',
    processCode: '',
  },
  {
    businessUnit: '75025 - DE Ohio Other - Elec',
    respCenter: '9929 - DE Ohio Accounting Other',
    capitalOperUnit: 'RRB1',
    omOperUnit: 'RRB1',
    fundingProject: 'RESBLDOH',
    businessUnitNumber: '75025',
    capitalAccount: '0108620',
    omAccount: '0935100',
    processCode: '',
  },
  {
    businessUnit: '75026 - DE Ohio Gas Delivery',
    respCenter: '9929 - DE Ohio Accounting Other',
    capitalOperUnit: 'GD10',
    omOperUnit: 'GD10',
    fundingProject: 'RESBLDOH',
    businessUnitNumber: '75026',
    capitalAccount: '0108620',
    omAccount: '0935200',
    processCode: '',
  },
  {
    businessUnit: '75027 - DE Ohio Gas Customer',
    respCenter: '9929 - DE Ohio Accounting Other',
    capitalOperUnit: 'CSOG',
    omOperUnit: 'CSOG',
    fundingProject: 'RESBLDOH',
    businessUnitNumber: '75027',
    capitalAccount: '0108620',
    omAccount: '0935200',
    processCode: '',
  },
  {
    businessUnit: '75028 - DE Ohio Other - Gas',
    respCenter: '9929 - DE Ohio Accounting Other',
    capitalOperUnit: 'GDOH',
    omOperUnit: 'GDOH',
    fundingProject: 'RESBLDOH',
    businessUnitNumber: '75028',
    capitalAccount: '0108620',
    omAccount: '0935200',
    processCode: '',
  },
  {
    businessUnit: '75080 - DE Kentucky Other - Elec',
    respCenter: '9928 - DE Kentucky Accounting Other',
    capitalOperUnit: 'RRB3',
    omOperUnit: 'RRB3',
    fundingProject: 'RESBLKY',
    businessUnitNumber: '75080',
    capitalAccount: '0108620',
    omAccount: '0935100',
    processCode: '',
  },
  {
    businessUnit: '75084 - DE Kentucky Power Deliv - Ele',
    respCenter: '9928 - DE Kentucky Accounting Other',
    capitalOperUnit: 'BLDK',
    omOperUnit: 'BLDK',
    fundingProject: 'RESBLKY',
    businessUnitNumber: '75084',
    capitalAccount: '0108620',
    omAccount: '0935100',
    processCode: 'SACONST',
  },
  {
    businessUnit: '75085 - DE Kentucky Cus Service - Ele',
    respCenter: '9928 - DE Kentucky Accounting Other',
    capitalOperUnit: 'ACK1',
    omOperUnit: 'ACK1',
    fundingProject: 'RESBLKY',
    businessUnitNumber: '75085',
    capitalAccount: '0108620',
    omAccount: '0935100',
    processCode: '',
  },
  {
    businessUnit: '75086 - DE Kentucky Gas Delivery',
    respCenter: '9928 - DE Kentucky Accounting Other',
    capitalOperUnit: 'GD70',
    omOperUnit: 'GD70',
    fundingProject: 'RESBLKY',
    businessUnitNumber: '75086',
    capitalAccount: '0108620',
    omAccount: '0935200',
    processCode: '',
  },
  {
    businessUnit: '75087 - DE Kentucky Gas Customer',
    respCenter: '9928 - DE Kentucky Accounting Other',
    capitalOperUnit: 'CSKG',
    omOperUnit: 'CSKG',
    fundingProject: 'RESBLKY',
    businessUnitNumber: '75087',
    capitalAccount: '0108620',
    omAccount: '0935200',
    processCode: '',
  },
  {
    businessUnit: '75088 - DE Kentucky Gas Other',
    respCenter: '9928 - DE Kentucky Accounting Other',
    capitalOperUnit: 'GDKY',
    omOperUnit: 'GDKY',
    fundingProject: 'RESBLKY',
    businessUnitNumber: '75088',
    capitalAccount: '0108620',
    omAccount: '0935200',
    processCode: '',
  },
  {
    businessUnit: '75110 - DE Indiana Other',
    respCenter: '9927 - DE Indiana Accounting Other',
    capitalOperUnit: 'RRB2',
    omOperUnit: 'RRB2',
    fundingProject: 'INNONUTIL',
    businessUnitNumber: '75110',
    capitalAccount: '0108620',
    omAccount: '0935100',
    processCode: '',
  },
  {
    businessUnit: '75111 - DE Indiana Fossil',
    respCenter: '9927 - DE Indiana Accounting Other',
    capitalOperUnit: 'WR26',
    omOperUnit: 'WR26',
    fundingProject: 'RES75111',
    businessUnitNumber: '75111',
    capitalAccount: '0108620',
    omAccount: '0935100',
    processCode: '',
  },
  {
    businessUnit: '75115 - DE Indiana Power Delivery',
    respCenter: '9927 - DE Indiana Accounting Other',
    capitalOperUnit: 'BLDI',
    omOperUnit: 'BLDI',
    fundingProject: 'RESBLDINO',
    businessUnitNumber: '75115',
    capitalAccount: '0108620',
    omAccount: '0935100',
    processCode: 'SACONST',
  },
  {
    businessUnit: '75116 - DE Indiana Customer Services',
    respCenter: '9927 - DE Indiana Accounting Other',
    capitalOperUnit: 'CSIE',
    omOperUnit: 'CSIE',
    fundingProject: 'RESBLDIN',
    businessUnitNumber: '75116',
    capitalAccount: '0108620',
    omAccount: '0935100',
    processCode: '',
  },
];

export const DOA_PROJFUND_EMAILS = [
  'jared.kohler@duke-energy.com',
  'brian.weisker@duke-energy.com',
];

export const DOA_RE_BUILDING_EMAILS = [
  'adrian.acuna@duke-energy.com',
  'ashley.hess@duke-energy.com',
  'robert.veit@duke-energy.com',
];
